import { Component } from 'react';
import { FormCheck } from 'react-bootstrap';
import { $Formutil, connect, Form, RadioGroup } from 'react-bootstrap-formutil';
import Alert from 'components/base/Alert';
import FormGroup from 'components/FormGroup';
import Toast from 'components/Toast';
import { IS_TIGER_SELF } from 'utils/constants';
import './style.scss';

const QUESTIONS: string[] = [
    __('1. Do you use market data solely for your personal, non-business use?'),
    __('2. Do you receive market data for your business or any other entity?'),
    __('3. Are you currently registered or qualified with the SEC or the CFTC?'),
    __(
        '4. Are you currently registered or qualified with any securities agency, any securities exchange, association or regulatory body, or any commodities or futures contract market, association or regulatory body, in the United States or elsewhere?'
    ),
    __(
        '5. Whether you are located within or outside of the United States, do you perform any functions that are similar to those that require an individual to register or qualify with the SEC, the CFTC, any other securities agency or regulatory body, any securities exchange or association, or any commodities or futures contract market, association or regulatory body?'
    ),
    __('6. Are you engaged to provide investment advice to any individual or entity?'),
    __('7. Are you engaged as an asset manager?'),
    __('8. Do you use the capital of any other individual or entity in the conduct of your trading?'),
    __('9. Do you conduct trading for the benefit of a corporation, partnership, or other entity?'),
    __(
        '10. Have you entered into any agreement to share the profit of your trading activities or receive compensation for your trading activities?'
    ),
    __(
        '11. Are you receiving office space, equipment or other benefits in exchange for your trading or work as a financial consultant to any person, firm or business entity?'
    ),
    __(
        '12. Are you distributing, redistributing, publish, making available or otherwise providing any market data from the service to any third party in any manner?'
    )
];

// 默认选yes的选项
const defaultYesOptionIndexList = [0];

// 非专业用户默认options
const defaultOptionsValue = new Array(QUESTIONS.length)
    .fill('')
    .map((item, index) => (defaultYesOptionIndexList.includes(index) ? '1' : '0'));

const formatValue2Form = (value: string) => {
    const result = new Array(QUESTIONS.length).fill('0');

    value.split(',').forEach(item => {
        if (item) {
            result[Number(item) - 1] = '1';
        }
    });

    return result;
};

interface QuestionnaireProps {
    $formutil: $Formutil;
    value?: string; // '1,2,3,4,5,6'
    onChange?(value: string): void;
    disabled?: boolean;
}

class Questionnaire extends Component<QuestionnaireProps> {
    static defaultProps: Partial<QuestionnaireProps> = {
        // 针对加盟商默认展开, TODO: 待确认，需要改成统一的
        disabled: !IS_TIGER_SELF
    };

    calcIsNonPro = (arr: []) => {
        return arr?.every((value, index) => {
            return value === defaultOptionsValue[index];
        });
    };

    defaultValues = {
        // 有默认值取默认值 没有默认值，取非专业用户选项
        // 外部is_professional为number类型，内部处理，使用RadioGroup处理，所以使用string类型
        // 需注意字符串类型 '0' 的处理问题
        question:
            this.props.value || this.props.$formutil.$params.is_professional === 1
                ? formatValue2Form(this.props.value || '')
                : defaultOptionsValue,
        professional: this.props.$formutil.$params.is_professional ? '1' : '0'
    };

    renderValue = $formutil => {
        const { question, professional, agree } = $formutil.$params;

        if (agree === '0') {
            setTimeout(() => {
                this.props.onChange!('disagree');
            });
        }

        question &&
            setTimeout(() => {
                if ($formutil.$invalid) {
                    this.props.onChange!('required');
                } else {
                    this.props.onChange!(
                        question
                            .map((value, index) => {
                                return Number(value) ? index + 1 : false;
                            })
                            .filter(Boolean)
                            .join(',')
                    );
                }
            });

        // 处理 is_professional 值
        this.props.$formutil.$setValues({
            is_professional: professional === '1' ? 1 : 0
        });
    };

    handleProfessionalChange = $formutil => {
        const { question } = $formutil.$params;

        // 用户选择非默认选项时，置为专业用户
        $formutil.$setValues({
            professional: this.calcIsNonPro(question) ? '0' : '1'
        });

        this.renderValue($formutil);
    };

    handleAgreeChange = (value, $formutil) => {
        if (value === '0') {
            Toast.show(__('Please confirm and check the authenticity of the consent information'));
        }

        this.renderValue($formutil);
    };

    public render() {
        const { disabled } = this.props;

        return (
            <Form
                $defaultValues={this.defaultValues}
                $onFormChange={this.renderValue}
                render={($formutil: $Formutil<any>) => {
                    const renderContent = () => (
                        <>
                            <p className="description">
                                {__(
                                    'Many exchanges employ a two-tiered market data pricing structure based on whether the customer receiving the data is classified as a "non-professional" or "professional" receipient. The primary effect of this classification is the cost of the service for each user status, and you will need to report more detailed information to the exchange.'
                                )}
                            </p>
                            <h5>{__('NON-PROFESSIONAL USER DEFINITION')}</h5>
                            <p className="description">
                                {__(
                                    'Non-Professional users refer to individual users who access information solely for the purpose of managing their personal or family investments. In addition, to be Non-Professional users, all of the following must be true:'
                                )}
                            </p>
                            <ul className="desc-ul">
                                <li>
                                    {__(
                                        'The user is not currently registered or qualified as a professional securities/futures trader with any national, state or international exchange, self-regulatory organizations or financial regulatory authorities.'
                                    )}
                                </li>
                                <li>{__('The user does not currently act in any capacity as investment advisor.')}</li>
                                <li>{__('The user does not use the data for any commercial/business purposes.')}</li>
                                <li>
                                    {__(
                                        'The user does not distribute, republish or provide any data from the service to any other party in any manner.'
                                    )}
                                </li>
                            </ul>
                            <p className="description">
                                {__(
                                    'Market Data Subscription Agreement requests you to comply with the terms and conditions herein and to declare your subscriber status to be either a Non-Professional or a Professional. TradeUP will, at its sole and absolute discretion, determine your subscriber status to provide you with the market data and charge the relevant fee accordingly. Please confirm a response to each question.'
                                )}
                            </p>
                            {QUESTIONS.map((value, index) => {
                                return (
                                    <FormGroup
                                        key={index}
                                        label={<p className="description">{value}</p>}
                                        className="hide-error"
                                        required
                                        validMessage={{
                                            required: __('Please finish the questionnaire before continue')
                                        }}
                                        name={`question[${index}]`}
                                        $onFieldChange={() => this.handleProfessionalChange($formutil)}>
                                        <RadioGroup>
                                            <FormCheck
                                                type="radio"
                                                id={`question${index}_1`}
                                                inline
                                                value="1"
                                                disabled={disabled}
                                                label={__('Yes')}
                                            />
                                            <FormCheck
                                                type="radio"
                                                id={`question${index}_0`}
                                                inline
                                                value="0"
                                                disabled={disabled}
                                                label={__('No')}
                                            />
                                        </RadioGroup>
                                    </FormGroup>
                                );
                            })}
                            <p>
                                {__(
                                    'If you do not meet any of the above criteria and you use the market data for your own personal non-business investments, then you are considered a Non-Professional user. Based on the information above, l confirm to have duly answered all the preceding questions and l am a'
                                )}
                            </p>
                            <FormGroup name="professional">
                                <RadioGroup>
                                    <FormCheck
                                        type="radio"
                                        id="professional_1"
                                        inline
                                        value="1"
                                        disabled
                                        label={__('Professional')}
                                    />
                                    <FormCheck
                                        type="radio"
                                        id="professional_0"
                                        inline
                                        value="0"
                                        disabled
                                        label={__('Non-Professional')}
                                    />
                                </RadioGroup>
                            </FormGroup>
                            <div className="agreement-container">
                                <p>
                                    {__(
                                        'I agree to authorize TradeUP to process my personal information (name, occupation, address, name of employer, address of employer,  industry of employer, position, etc.) in accordance with the requirements of the exchange, including but not limited to market data application and provision of the exchange based on audit requirements. I acknowledge that the foregoing information and all other information provided is true and correct and agree to notify TradeUP by writing of any material changes therein. l authorize TradeUP to confirm the accuracy of the information it deems necessary.'
                                    )}
                                </p>
                                <FormGroup
                                    name="agree"
                                    $defaultValue="1"
                                    checker={value => {
                                        if (disabled) {
                                            return true;
                                        }

                                        return (
                                            value === '1' ||
                                            __('Please confirm and check the authenticity of the consent information')
                                        );
                                    }}
                                    $onFieldChange={value => this.handleAgreeChange(value, $formutil)}
                                    disabled={disabled}>
                                    <RadioGroup>
                                        <FormCheck
                                            type="radio"
                                            value="1"
                                            inline
                                            id="agree_1"
                                            label={__('Agree')}
                                            disabled={disabled}
                                        />
                                        <FormCheck
                                            type="radio"
                                            value="0"
                                            id="agree_0"
                                            inline
                                            label={__('Disagree')}
                                            disabled={disabled}
                                        />
                                    </RadioGroup>
                                </FormGroup>
                            </div>
                        </>
                    );

                    return (
                        <div className="questionnaire-root">
                            <h3 className="open-title">{__('Non-Professional Qualification Questionnaire')}</h3>
                            {renderContent()}
                            {$formutil.$errors && $formutil.$errors.question && (
                                <Alert variant="warning" className="mt-4">
                                    {__('Please finish the questionnaire before continue')}
                                </Alert>
                            )}
                            {$formutil.$errors && $formutil.$errors.agree && (
                                <Alert variant="warning" className="mt-4">
                                    {__('Please confirm and check the authenticity of the consent information')}
                                </Alert>
                            )}
                        </div>
                    );
                }}
            />
        );
    }
}

export default connect(Questionnaire);
